module.exports = __webpack_public_path__ + "img/9_77.5aec45bf.png";